<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 md3>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>device_hub</v-icon>
            <v-toolbar-title class="ml-0">Пользователи по ролям</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="addUser" class="mx-0">
              <v-icon class="mx-0" dark>add</v-icon>
            </v-btn>
          </v-system-bar>
          <v-layout row wrap>
            <v-flex xs12 class="ma-2">
              <v-list dense>
                <v-list-group
                  v-model="item.active"
                  v-for="item in user_roles"
                  :key="item.title"
                  class="sub_item_role"
                >
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(subItem, index) in item.posts" :key="index" @click="nodeClicked(subItem)"
                               class="pl-2">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-icon class="small-icon">fa-user</v-icon>
                        {{ subItem.fullname }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon ripple @click.stop="detachRole(subItem, item.id)"><v-icon color="red">close</v-icon></v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list-group>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>playlist_add_check</v-icon>
            <v-toolbar-title class="ml-1">Права</v-toolbar-title>
          </v-system-bar>
          <v-layout row wrap>
            <v-flex xs12 class="pl-4 pb-0 mt-3" v-if="currentNode && currentRole">
              <p class="subheading">Установить права для {{nodeName}}</p>
              <p class="subheading">Выбрана роль: {{currentRole.name}}</p>
            </v-flex>
            <v-flex xs12 class="pl-4 pb-0 mt-3" v-if="currentRole && !currentNode">
              <span class="subheading">Редактировать роль</span>
            </v-flex>
            <v-flex xs8 class="pl-4" v-if="currentRole && !currentNode">
              <v-text-field v-model="currentRole.name"  single-line></v-text-field>
            </v-flex>
            <v-flex xs4 class="text-xs-right" :offset-xs8="currentNode">
              <v-btn color="success" dark @click="saveElement" v-if="currentRole || currentNode" small>Сохранить</v-btn>
            </v-flex>
            
            <v-flex xs12>
              <b class="ml-4">Системные интерфейсы</b>
              <v-data-table :items="system_interfaces" hide-actions :headers="headers">
                <template slot="items" slot-scope="props" v-if="currentRole || currentNode">
                  <td><span :class="{'pl-3':!props.item.is_module, 'body-2':props.item.is_module}">{{ props.item.name }}</span></td>
                  <td><v-checkbox v-model="props.item.access[0].check" v-if="props.item.access[0]" hide-details></v-checkbox></td>
                  <td><v-checkbox v-model="props.item.access[1].check" v-if="props.item.access[1]" hide-details></v-checkbox></td>
                  <td><v-checkbox v-model="props.item.access[2].check" v-if="props.item.access[2]" hide-details></v-checkbox></td>
                  <td><v-checkbox v-model="props.item.access[3].check" v-if="props.item.access[3]" hide-details></v-checkbox></td>
                </template>
                <template slot="no-data">
                  Отсутствуют интерфейсы данной группы
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <b class="ml-4">Групповые интерфейсы</b>
              <v-data-table :items="group_interfaces" hide-actions :headers="headers">
                <template slot="items" slot-scope="props" v-if="currentRole || currentNode">
                  <td><span :class="{'pl-3':!props.item.is_module, 'body-2':props.item.is_module}">{{ props.item.name }}</span></td>
                  <td><v-checkbox v-model="props.item.access[0].check" v-if="props.item.access[0]" hide-details></v-checkbox></td>
                  <td><v-checkbox v-model="props.item.access[1].check" v-if="props.item.access[1]" hide-details></v-checkbox></td>
                  <td><v-checkbox v-model="props.item.access[2].check" v-if="props.item.access[2]" hide-details></v-checkbox></td>
                  <td><v-checkbox v-model="props.item.access[3].check" v-if="props.item.access[3]" hide-details></v-checkbox></td>
                </template>
                <template slot="no-data">
                  Отсутствуют интерфейсы данной группы
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md3>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>storage</v-icon>
            <v-toolbar-title class="ml-1">Роли</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="addRole" class="mx-0" v-if="accesses.role_system_create">
              <v-icon class="mx-0" dark>add</v-icon>
            </v-btn>
          </v-system-bar>
          <v-layout row wrap>
            <v-flex xs12>
              <v-list subheader>
                <v-list-tile dense v-for="item in roles" :key="item.id" @click="editRole(item)">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      v-if="item.type!==role_types.system_default && item.type!==role_types.root && accesses.role_system_delete"
                      @click.stop="deleteRole(item)" icon>
                      <v-icon color="red">close</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  
    <v-dialog v-model="dialog" max-width="850" persistent>
      <new-user-form :roles="system_roles" v-if="dialog" @save="addUserRole" @close-dialog="dialog=false"></new-user-form>
    </v-dialog>

  </v-container>
</template>

<script>
  import NewUserForm from './NewUserForm'
  import {mapGetters} from 'vuex'
  
  export default {
    name : 'SystemRoles',
    
    components:{
      NewUserForm
    },
    
    data() {
      return {
        role_types : {
          private : 0,
          root : 1,
          default : 2,
          other : 3,
          system_default : 4
        },
        currentRole : null,
        currentNode : null,
        nodeName : '',
        user_roles : [],
        group_interfaces : [],
        system_interfaces : [],
        headers : [
          { text : 'Модуль/Интерфейс', align : 'left', sortable : false },
          { text : 'Доступ', sortable : false, align : 'center' },
          { text : 'Создание', sortable : false, align : 'center'  },
          { text : 'Редактирование', sortable : false, align : 'center'  },
          { text : 'Удаление', sortable : false, align : 'center'  },
        ],
        dialog: false,
      }
    },
    
    computed:{
      system_roles(){
        return this.roles.filter( role => role.type === 0 )
      },
      ...mapGetters('orgstructure/interfaces', {
        roles: 'system_roles'
      }),
      accesses(){
        return this.$store.state.app.account.accesses['interfaces'] || {}
      }
    },
    
    mounted() {
      if(!this.accesses.role_system_access){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      } else {
        this.getRoles()
        this.getUserRoles()
      }
    },
    
    methods : {
      getUserRoles(){
        this.$store.dispatch('orgstructure/interfaces/userRoles').then( response => {
          this.user_roles = response.roles
          if(response.individual.length>0){
            this.user_roles.push({name: 'Индивидуальный набор', id: 0, posts:response.individual})
          }
        })
      },
      
      getRoles() {
        this.$store.dispatch('orgstructure/interfaces/list', 'system')
      },
      
      nodeClicked( node ) {
        if(this.accesses.role_system_update){
          this.currentNode = node
          this.nodeName = 'пост "' + node.fullname + '"'
  
          this.$store.dispatch('orgstructure/interfaces/relationSystem', node.role_id).then( response => {
            this.currentRole = response.role
            this.group_interfaces = response.group_interfaces
            this.system_interfaces = response.system_interfaces
          })
        }
        
      },
      
      addRole() {
        this.$store.dispatch('orgstructure/interfaces/getInterfaces', 'all').then( response => {
          this.group_interfaces = response.group
          this.system_interfaces = response.system
        })
        this.currentNode = null
        this.currentRole = {
          id : false,
          name : 'Новая роль'
        }
      },
      
      editRole( item ) {
        if(this.accesses.role_system_update){
          this.$store.dispatch('orgstructure/interfaces/relationSystem', item.id).then( response => {
            this.currentRole = response.role
            this.group_interfaces = response.group_interfaces
            this.system_interfaces = response.system_interfaces
          })
          this.currentNode = null
        }
      },
      
      deleteRole( item ) {
        this.$store.dispatch('orgstructure/interfaces/delete', {id: item.id, type: 'system'} ).then( response => {
          if( this.currentRole && item.id === this.currentRole.id ) this.currentRole = null
        })
      },
      
      saveElement() {
        //Создается новая роль (кнопкой +)
        if( !this.currentRole.id ) {
          let data = {
            personal : 0,
            role_name : this.currentRole.name,
            interfaces : this.group_interfaces.concat(this.system_interfaces)
          }
          this.$store.dispatch('orgstructure/interfaces/create', {type: 'system', data: data}).then( response => {
            this.currentRole = null
            this.currentNode = null
          } )
        } else {
          //Сохранение отредактированной роли
          let data = {
            role_name: this.currentRole.name,
            interfaces: this.group_interfaces.concat(this.system_interfaces)
          }
          this.$store.dispatch('orgstructure/interfaces/update', {id: this.currentRole.id,type: 'system', data: data}).then( response => {
            this.currentRole = null
            this.currentNode = null
          })
        }
      },
      
      addUser(){
        this.dialog = true
      },
  
      addUserRole(eventData){
        this.dialog = false
        if(eventData.role.id){
          let role = this.user_roles.find( role => role.id===eventData.role.id)
          if(typeof role === 'undefined'){
            role = eventData.role
            role.posts = []
            this.user_roles.push(role)
          }
          const index = role.posts.findIndex( post => post.id===eventData.post.id)
          if(index<0) {
            role.posts.push(eventData.post)
          }
        } else {
          let role = this.user_roles.find( role => role.id===0)
          if(typeof role === 'undefined'){
            role = {name: 'Индивидуальный набор', id: 0, posts:[]}
            this.user_roles.push(role)
          }
          role.posts.push(eventData.post)
        }
      },
  
      detachRole(post, id){
        this.$store.dispatch('orgstructure/interfaces/detachSystem', {id: post.id, role_id: post.role_id}).then( response => {
          const r_index = this.user_roles.findIndex( r => r.id===id )
          if(r_index>=0){
            let role = this.user_roles[r_index]
            const index = role.posts.findIndex( el => el.id===post.id)
            if(index>=0){
              role.posts.splice(index, 1)
            }
            if(role.posts.length===0) this.user_roles.splice(r_index, 1)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .sub_item_role .list__tile__title {
    white-space: inherit;
  }
  
  .sub_item_role a.list__group__items--no-action .list__tile {
    padding-left: 22px !important;
  }
  
  i.small-icon {
    font-size: 12px !important;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Roles/SystemRoles.vue